import { useCallback } from 'react';
import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from '@/components/ui/resizable';
import { CategoryList } from './CategoryList';
import { CategoryChannels } from './CategoryChannels';
import { CategoryModals } from './CategoryModals';
import { useCategoryStore } from '@/stores/categoryStore';
import { toast } from 'sonner';
import type { VersionAwareProps } from '@/features/versions/types/props';

export function CategorySplitView(props: VersionAwareProps) {
  const { openCreateModal: originalOpenCreateModal } = useCategoryStore();

  // Wrap the actions with read-only checks
  const handleAction = useCallback((action: () => void, _actionName: string) => {
    if (props.isReadOnly) {
      toast.error("This is a published version. Create a new version to make changes.");
      return;
    }
    action();
  }, [props.isReadOnly]);

  const wrappedOpenCreateModal = useCallback(() => {
    handleAction(originalOpenCreateModal, 'create');
  }, [handleAction, originalOpenCreateModal]);

  return (
    <ResizablePanelGroup 
      orientation="horizontal"
      className="min-h-[calc(100vh-4rem)] w-full max-w-none"
    >
      <ResizablePanel 
        defaultSize={35} 
        minSize={30}
        maxSize={45}
        className="overflow-auto"
      >
        <CategoryList 
          providerId={props.providerId}
          versionId={props.versionId}
          isReadOnly={props.isReadOnly}
          onCreateCategory={wrappedOpenCreateModal}
        />
      </ResizablePanel>
      <ResizableHandle />
      <ResizablePanel defaultSize={75}>
        <div className="h-full p-4 overflow-auto">
          <CategoryChannels 
            providerId={props.providerId}
            versionId={props.versionId}
            categoryId={useCategoryStore.getState().selectedCategory?.id || 0}
            isReadOnly={props.isReadOnly}
          />
        </div>
      </ResizablePanel>
      {!props.isReadOnly && (
        <CategoryModals 
          providerId={props.providerId}
          versionId={props.versionId}
        />
      )}
    </ResizablePanelGroup>
  );
} 